export const LANDING_PAGE_URL = (
  process.env.REACT_APP_LANDING_PAGE_URL ||
  (typeof window !== "undefined" && window.location.origin) ||
  "http://localhost:3335"
).replace(/\/$/, "");

export const slugify = (text) => {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

export const getBlogMarketingUrl = (category, slugOrId) => {
  const catSlug = slugify(category) || "upsc-preparation";
  const identifier = slugify(slugOrId) || slugOrId || "custom-slug";
  return `${LANDING_PAGE_URL}/blog/${catSlug}/${identifier}`;
};
